module.exports = __webpack_public_path__ + "img/port7.de256485.png";